import { useEffect, useState } from 'react'
import { Badge, Container, SpaceBetween } from '@amzn/awsui-components-react/polaris'
import { getTotalByKeyList } from '../reusable/AllocationUtils'
import useStore from '../../Store'
import { BADGE_COLOR, getDefaultAllocation } from '../../Constant'
import { Link } from '@amzn/awsui-components-react'
import ManageHistoryHeader from './ManageHistoryHeader'
import ManageHistoryWeekReportModal from './ManageHistoryWeekReportModal'
import { useAppContext } from '../../../context'
import { GridApi } from 'ag-grid-community'
import { createAllocationEmptyState, getHistoryColumnDefs } from './HistoryUtils'
import GenericAGGridTable from '../grid/GenericAGGridTable'

const ManageHistoryTable = (props) => {
    const appContext = useAppContext()
    const apiClient = appContext.apiClient

    const selectedTeam = useStore((state) => state.selectedTeam)
    const setSelectedAllocationReportsToDelete = useStore(
        (state) => state.setSelectedAllocationReportsToDelete,
    )
    const historyAllocationReports: any[] = useStore((state) => state.historyAllocationReports)
    const setTotalAllocation = useStore((state) => state.setTotalAllocation)
    const setAllocationByEmployeeTypeTotalBIS = useStore(
        (state) => state.setAllocationByEmployeeTypeTotalBIS,
    )
    const setAllocationTotalBIS = useStore((state) => state.setAllocationTotalBIS)
    const setTotalAllocationByEmployeeType = useStore(
        (state) => state.setTotalAllocationByEmployeeType,
    )

    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [allocationWeekDetailModalVisible, setAllocationWeekDetailModalVisible] =
        useState<boolean>(false)
    const [clickedWeek, setClickedWeek] = useState<string>('')
    const [clickedReportHcDetailNote, setClickedReportHcDetailNote] = useState<string>('')
    const [clickedReportWeeklyNote, setClickedReportWeeklyNote] = useState<string>('')
    const [clickedReportSystemNote, setClickedReportSystemNote] = useState<string>('')
    const [gridApi, setGridApi] = useState<GridApi>()

    const getReportOnTeamAndDate = async (date) => {
        const URL = `/allocation/team/${selectedTeam.value}/week/${date}`
        await apiClient
            .get(URL)
            .then((response) => {
                const res = response.data
                if (res.length > 0) {
                    const headcountData = res[0].headcount_by_employee_type
                    setAllocationByEmployeeTypeTotalBIS(headcountData)
                    setAllocationTotalBIS(res[0].total_headcount)
                    setTotalAllocationByEmployeeType(
                        Object.fromEntries(
                            Object.keys(headcountData).map((employeeType) => [
                                employeeType,
                                getTotalByKeyList(
                                    res,
                                    `allocation_by_employee_type.${employeeType}`,
                                ),
                            ]),
                        ),
                    )
                    setTotalAllocation(getTotalByKeyList(res, 'allocation_value'))
                }
            })
            .catch((error) => {
                setAllocationByEmployeeTypeTotalBIS(getDefaultAllocation())
                setAllocationTotalBIS('0')
                setTotalAllocationByEmployeeType(getDefaultAllocation())
                setTotalAllocation('0')
                console.error(error)
            })
    }

    const allocationWeekCellRenderer = (params) => (
        <SpaceBetween size='s' direction='horizontal'>
            <Link
                onFollow={() => {
                    getReportOnTeamAndDate(params.value)
                    setAllocationWeekDetailModalVisible(true)
                    setClickedWeek(params.value)
                    setClickedReportHcDetailNote(params.data?.hr_detail_note || '-')
                    setClickedReportSystemNote(params.data?.note || '-')
                    setClickedReportWeeklyNote(params.data?.weekly_note || '-')
                }}
            >
                {params.value}
            </Link>
            {params.data.badge ? <Badge color={BADGE_COLOR.RED}>{params.data.badge}</Badge> : <></>}
        </SpaceBetween>
    )
    const columnDefs = getHistoryColumnDefs(allocationWeekCellRenderer)

    const onSelectionChanged = (event) => {
        setSelectedAllocationReportsToDelete(event.api.getSelectedRows())
    }

    useEffect(() => {
        gridApi?.deselectAll()
    }, [gridApi, historyAllocationReports])

    useEffect(() => {
        if (isLoading) {
            gridApi?.showLoadingOverlay()
        } else {
            gridApi?.setGridOption('rowData', historyAllocationReports)
        }
    }, [gridApi, historyAllocationReports, isLoading])

    return (
        <Container
            fitHeight
            header={
                <ManageHistoryHeader
                    gridApi={gridApi}
                    isLoading={isLoading}
                    onHistoryLoadingChange={setIsLoading}
                    isTeamSelected={props.isTeamSelected}
                    teamId={props.teamId}
                />
            }
        >
            <GenericAGGridTable
                setGridApi={setGridApi}
                colDefs={columnDefs}
                rowSelectionType='multiple'
                onSelectionChanged={onSelectionChanged}
                noRowsOverlayComponent={createAllocationEmptyState(false)}
                includeTableHeader={false}
                actionDropdownPermission={true}
            />
            <ManageHistoryWeekReportModal
                isModalVisible={allocationWeekDetailModalVisible}
                setIsModalVisible={setAllocationWeekDetailModalVisible}
                clickedWeek={clickedWeek}
                clickedSystemNote={clickedReportSystemNote}
                clickedHcDetailNote={clickedReportHcDetailNote}
                clickedWeeklyNote={clickedReportWeeklyNote}
            />
        </Container>
    )
}

export default ManageHistoryTable
